/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import {
  HeaderTitle,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
} from '../../../services/settings/appStyle/global.style';
import { IconButton, Loader, Table } from '../../../Components/uielements';
import { useUserContext } from '../../../hooks/UserContext';
import { AddPlusIcon } from '../../../Components/icons';
import { CompanyContainer } from './company.style';
import CompanyService from '../../../services/bioplus-services/company';
import { useCompany } from '../../../hooks/CompanyContext';
import { InviteCompanyModal } from './modals';
import { IntlMessages } from '../../../helper/langHelper';

const CorporateCompany = () => {
  const [inviteUser, setInviteUser] = useState();
  const userContext = useUserContext();
  const companyContext = useCompany();
  const parentId = userContext?.company?.companyId?.id;
  const companyFilter = companyContext?.company?._id;

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const usersQuery = useQuery(['companies', parentId, companyFilter, page, pageSize], () =>
    CompanyService.listByParent(parentId, { companyId: companyFilter }, page, pageSize)
  );
  const userTableData = usersQuery?.data?.items ?? [];

  //   table coulmns
  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.name" />,
        accessor: 'name',
        Cell: (cellData) => <TableCell>{cellData.value}</TableCell>,
        width: '20%',
      },
      {
        Header: <IntlMessages id="table.col.email" />,
        accessor: 'createdBy',
        width: '20%',
      },
      {
        Header: <IntlMessages id="label.street" />,
        accessor: 'addressStreet',
        width: '20%',
      },
      {
        Header: <IntlMessages id="label.town" />,
        accessor: 'addressTown',
        width: '20%',
      },
      {
        Header: <IntlMessages id="label.state" />,
        accessor: 'addressState',
        width: '20%',
      },
    ],
    []
  );

  const handleClosed = () => {
    setInviteUser(undefined);
  };

  if (usersQuery.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.companies" />
        </HeaderTitle>
        <IconButton
          text={<IntlMessages id="button.text.inviteCompany" />}
          onClick={() => setInviteUser(true)}
          icon={<AddPlusIcon />}
        />
      </CompanyContainer>
      <TableWrapper>
        <Table data={userTableData} columns={userColumns} hasFooter={false} />
      </TableWrapper>
      {inviteUser && <InviteCompanyModal onClose={handleClosed} />}
    </StyledContainer>
  );
};

export default CorporateCompany;
